/**
 * Terms + Privacy checkbox used inside the post-SMS Terms gate.
 */
import { detectAppLocale, getPrivacyUrl, getTermsUrl } from '../constants/legalUrls';

const COPY = {
  en: {
    prefix: 'I agree to the',
    terms: 'Terms of Service',
    and: 'and',
    privacy: 'Privacy Policy',
  },
  pt: {
    prefix: 'Eu concordo com os',
    terms: 'Termos de Serviço',
    and: 'e a',
    privacy: 'Política de Privacidade',
  },
} as const;

interface TermsConsentProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  className?: string;
}

export default function TermsConsent({
  checked,
  onChange,
  disabled = false,
  className = '',
}: TermsConsentProps) {
  const locale = detectAppLocale();
  const copy = locale === 'pt' ? COPY.pt : COPY.en;
  const termsUrl = getTermsUrl(locale);
  const privacyUrl = getPrivacyUrl(locale);

  return (
    <label
      className={`flex cursor-pointer items-start gap-3 text-left text-sm leading-snug text-x9-marineSoft ${className}`}
    >
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 h-4 w-4 shrink-0 rounded border-x9-marine/30 bg-white accent-x9-marine"
        aria-required="true"
      />
      <span>
        {copy.prefix}{' '}
        <a
          href={termsUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="font-medium text-x9-ink underline decoration-x9-marine/30 underline-offset-2 hover:decoration-x9-marine"
          onClick={(e) => e.stopPropagation()}
        >
          {copy.terms}
        </a>{' '}
        {copy.and}{' '}
        <a
          href={privacyUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="font-medium text-x9-ink underline decoration-x9-marine/30 underline-offset-2 hover:decoration-x9-marine"
          onClick={(e) => e.stopPropagation()}
        >
          {copy.privacy}
        </a>
      </span>
    </label>
  );
}
